import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return data?.map(item => ({
      ...item,
      procedure_ids: item.procedures.map(item => item.procedure_id),
    }))
  }, [data])
}
